export {
  type IamClient,
  iamClientApps,
  getLoginHeadersForApp,
} from './iam-client/iam-client'
export {
  groupDomainAssignees,
  getAssigneeDisplayName,
} from './components/domainAssignees/utils'
export { groupDomainsByArea } from './utils/groupDomainsByArea'
export type { DomainArea } from './utils/groupDomainsByArea'
export {
  ACCOUNT_DOMAINS,
  TENANTLESS_ACCOUNT,
  accountDomainPermissions,
  domainsCoveringAccount,
  domainsModifyingAccount,
} from './utils/accountDomains'
export type { AccountDomain, AccountTenancy } from './utils/accountDomains'
